import { post, get } from '@/utils/https.js'


export function upLoad(params) {
    return post(`upload`, params)
}

export function getList(params) {
    return get(`download`, params)
}
